export default "__VITE_ASSET__DEVMxZkK__"